<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import {TipoEvento, verificarSessionStorage} from '../../utils';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';

	const dispatch = createEventDispatcher();
	let parseConfiguracoes = [];

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			carregarConfiguracoesApp();
		else 
			replace("/login");
	});

	const carregarConfiguracoesApp = async () => {
		parseConfiguracoes = [];

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando configurações ...',
		});

		Object.keys(localStorage)
			.filter( nomeChave => nomeChave.includes('AVAL_CONFIG_APP_'))
			.forEach(variavel => {
				parseConfiguracoes.push({
					acoes: [{
						url: `#/painel/configuracoes/atualizar/${variavel}/LOCAL`,
						texto: 'Configurar'
					}],
					titulo: variavel,
					descricao: `Valor = ${localStorage.getItem(variavel)}`
				});				
			});

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Configurações da Aplicação">
	
	<GradeCartoes itens={parseConfiguracoes} componente={CartaoRetangulo} flexWrap={false} />
</PainelBox>
